import type { BalanceType } from 'shared/graphql/graphql'
import { numberToStringWithDecimals } from 'utils/number'

export const getFormattedValue = (item?: BalanceType | null) => {
  if (!item || item.value === null || item.value === undefined) return ''

  return numberToStringWithDecimals(item.value, 2)
}
